<template>
  <div class="e2e-gfx3d-board" style="margin: 10px 0px 10px 0px;">
    <geogebra-wrapper
      :width="fragment.width"
      :height="fragment.height"
      @onGfx3dApiReady="onGfx3dApiReady"
    />
    <ul style="color: red" class="e2e-gfx3d-error-logs">
      <li v-for="error in gfx3dErrors" :key="error.message">[Line: {{error.line}}] {{error.message}}</li>
    </ul>
  </div>
</template> 

<script>
import GeogebraWrapper from "./geogebra-wrapper.vue";

export default {
  components: { GeogebraWrapper },
  name: "fragment-gfx3d-board",
  props: ["fragment"],
  data() {
    return {
      gfx3dErrors: []
    };
  },
  methods: {
    async onGfx3dApiReady(api) {
      const that = this;
      // Fehler verfolgen
      api.addErrorListener(gfx3dError => {
        console.log("###########", gfx3dError);
        that.gfx3dErrors.push(gfx3dError);
      });
      // initiale modifikationen
      let { script, base64 } = this.fragment;
      if (base64) {
        await api.loadBase64(base64);
      }
      if (script) {
        await api.runScript(script);
      }
    }
  }
};
</script>
  

<style scoped>
</style>  